import { IDefineCommand, ICommand } from 'core-ts-types';
import { RegistrationAlertsServant } from '../../views/course_scheduler/servants/registration_alerts_servant';
import { SchedulerModel } from '../../views/course_scheduler/models/scheduler_model';
import { SwapCallbackServant } from '../servants/section_swap_callback_servant';
import { ISectionSwap } from '../interfaces/swap_section_interface';
import * as _4 from 'lodash4';
import { ICampusesDatasource } from '../../views/sections/datasources/campuses_datasource';
import { ILocationsDatasource } from '../../views/sections/datasources/locations_datasource';
import { ISectionTimesDatasource } from '../../views/sections/datasources/section_times_datasource';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { Campus } from '../../views/sections/builders/campus_builder';
import { SectionTime } from '../../views/sections/builders/section_time_builder';
import { Section } from '../../views/sections/builders/section_builder';
import { Location } from '../../views/sections/builders/location_builder';
import { ISectionLabelsDatasource } from '../../views/sections/datasources/section_labels_datasource';
import { ISectionLabel } from '../../interfaces/scheduler_interfaces';
import { INotificationDelegate } from '../../global/helpers/scheduler_notification_delegate';

interface ISwapResponseData {
  campuses: Campus[];
  locations: Location[];
  section_times: SectionTime[];
  sections: Section[];
  swap_from_section_ids: number[];
  swap_to_section_ids: number[];
  section_labels: ISectionLabel[];
}
angular
  .module('capability-ng-scheduler')
  .service(
    'getSwapCommand',
    function getSwapCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      log: any,
      pusherService: any,
      ngCourseSectionSwapModel: any,
      $timeout: ng.ITimeoutService,
      ngSchedulerModel: SchedulerModel,
      ngSwapCallbackServant: SwapCallbackServant,
      updateSwapSectionStatusCommand: ICommand,
      ngRegistrationAlertsServant: RegistrationAlertsServant,
      ngCampusesDatasource: ICampusesDatasource,
      ngLocationsDatasource: ILocationsDatasource,
      ngSectionTimesDatasource: ISectionTimesDatasource,
      ngSectionLabelsDatasource: ISectionLabelsDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngSchedulerNotificationDelegate: INotificationDelegate
    ) {
      'use strict';

      return defineCommandORM('getSwapCommand', function getSwapCommand(deferred, termId) {
        const schedulerModel = ngSchedulerModel.read();
        const swapCallback = (data: ISectionSwap) => {
          if (data.is_swapped) {
            ngSwapCallbackServant.swapSuccess(data);
          } else {
            ngSwapCallbackServant.swapFails(data);
          }
        };

        pusherService.bindToPusherEvent(schedulerModel.channel_name, 'registration_outcome_swap', swapCallback);

        $http.get('/reg/swap/term/' + termId).then(
          (response: { data: ISwapResponseData[] }) => {
            deferred.resolve(response.data);
            if (response.data && response.data[0]) {
              const data = response.data[0];
              ngCampusesDatasource.write(data.campuses);
              ngLocationsDatasource.write(data.locations);
              ngSectionLabelsDatasource.write(data.section_labels);
              ngSectionTimesDatasource.write(data.section_times);
              ngSectionsDatasource.write(data.sections);
              updateSwapSectionStatusCommand(data.swap_from_section_ids, 'REGISTERED');
              updateSwapSectionStatusCommand(data.swap_to_section_ids, 'PENDING');
            }
          },
          (response) => {
            log.issue('failed to get pending swaps');
            if (_4.has(response, 'data.detail')) {
              ngSchedulerNotificationDelegate.warn(response.data.detail);
            }
            deferred.reject(response.data);
          }
        );
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/get_swap_command.ts